module.exports = __webpack_public_path__ + "img/teaser-kurs-buchen-default.52aa563e.svg";